import _ from 'lodash';
import { ComponentProps } from 'react';
import {
  DataGrid,
  GridRowParams,
  GridToolbar,
  GridFilterModel,
  GridCellParams,
  getGridStringOperators,
} from '@mui/x-data-grid';
import { Box } from '@mui/material';

type DataGridProps = ComponentProps<typeof DataGrid>;

export type TableRowParams = GridRowParams;
export type TableFilterModel = GridFilterModel;
export type TableCellParams = GridCellParams;
export type FilterOption = 'equals' | 'contains' | string;

export const Table = ({
  styles = {},
  columns,
  ...props
}: {
  columns: DataGridProps['columns'] & { filterOperators?: FilterOption[] };
  showToolbar?: boolean;
  filterOptions?: FilterOption[];
  styles?: DataGridProps['sx'];
} & DataGridProps) => {
  return (
    <Box>
      <DataGrid
        {..._.omit(props, ['paginationMode', 'rowHeight', 'sx', 'slots'])}
        columns={columns.map((column) => {
          if (column.filterable === false) {
            return column;
          }
          return {
            ...column,
            filterOperators: getGridStringOperators().filter((operator) =>
              (columns.filterOperators || ['equals']).includes(
                operator.value.toString()
              )
            ),
          };
        })}
        paginationMode="server"
        rowHeight={45}
        sx={{
          minHeight: '340px',
          ...styles,
        }}
        slots={{ toolbar: GridToolbar, ...props.slots }}
      />
    </Box>
  );
};
